<template>
	<v-card class="grid-flex-container my-0" elevation="0" v-if="interactions">
		<v-container
			v-if="canView"
			:fluid="true"
			class="generic-grid-container pt-0 fluid"
			style="overflow-y: scroll"
		>
			<v-expansion-panels v-model="expansionPanel" inset>
				<form-interaction
					v-for="(interaction, index) in interactions"
					:key="index"
					:index="index"
					:currentInteraction="interaction"
					@remove="onRemoveInteraction"
					@saved="onInteractionSaved"
				/>
			</v-expansion-panels>
		</v-container>
		<div class="mt-1">
			<v-btn
				v-if="canAdd"
				class="primary float-left"
				@click="onAddInteraction()"
				>Add new Interaction</v-btn
			>
		</div>
	</v-card>
</template>
<script>
import FormInteraction from './FormInteraction.vue';
import { InteractionsGetters } from '../../../../store/getters';
import { InteractionsActions } from '../../../../store/actions';
import { mapGetters } from 'vuex';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';
export default {
	name: 'InventoryFormInteractions',
	data() {
		return {
			expansionPanel: null,
			interactions: [],
		};
	},
	mixins: [permissionsMixin],
	components: { FormInteraction },
	computed: {
		...mapGetters({
			currentInteractions: [InteractionsGetters.INTERACTIONS],
		}),
		canAdd() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Interactions.Add,
			]);
		},
		canView() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Interactions.View,
			]);
		},
	},
	mounted() {
		this.$store
			.dispatch(InteractionsActions.LOAD, this.$route.params.id)
			.then(() => {
				this.currentInteractions.forEach((item) => {
					item.IsNew = false;
					item.Index = this.interactions.length;
					this.interactions.push(item);
				});
			});
	},
	destroyed() {
		this.$store.dispatch(InteractionsActions.CLEAR);
	},

	methods: {
		closeAllPanels() {
			this.expansionPanel = null;
		},
		openPanel(index) {
			this.expansionPanel = index;
		},

		onAddInteraction() {
			let item = {
				InventoryId: this.$route.params.id,
				Conditions: [],
				Actions: [],
				OnLoad: false,
				OnChange: false,
				OnFocus: false,
				OnBlur: false,
				OnKeyPress: false,
				RevertOnOppositeTrigger: false,
				RevertOnOppositeValue: false,
				IsNew: true,
				Index: this.interactions.length,
			};
			this.interactions.push(item);
		},
		onRemoveInteraction(item) {
			let index = this.interactions.indexOf(item);
			if (index < 0) return;
			if (!item.Id) {
				this.interactions.splice(index, 1);
				return;
			}

			this.$store
				.dispatch(InteractionsActions.REMOVE, item.Id)
				.then((success) => {
					if (!success) return;
					this.interactions.splice(index, 1);
				});
		},
		onInteractionSaved({ oldItem, newItem }) {
			let index = this.interactions.indexOf(oldItem);
			if (index < 0) return;
			(newItem.IsNew = false), (newItem.Index = oldItem.Index);
			this.interactions.splice(index, 1, newItem);
		},
	},
};
</script>
